import { useMediaQuery as useMediaQueryNative } from "react-responsive";

import useMediaQuery from "../../../utils/media-queries";

import {
  StyledContainer,
  Dude,
  DecorationMiddle,
  DecorationMiddleTop,
  Savings,
  SavingsValue,
  DecorationMiddleBottom,
  DecorationMiddleBottomInner,
  DecorationRight,
  DecorationRightTop,
} from "./styles";

export function EyeCatcher() {
  const { isDesktop } = useMediaQuery();
  const isBetween = useMediaQueryNative({ query: "(max-width: 1000px)" });
  const isSmall = useMediaQueryNative({ query: "(max-width: 425px)" });
  return (
    <StyledContainer
      between={isBetween}
      small={isSmall}
      className={`${isBetween && "EyeCatcher--between"}`}
    >
      <Dude src="img/dude.png" alt="Very cool dude." small={isSmall} />
      {!isSmall && (
        <DecorationMiddle>
          <DecorationMiddleTop>
            <Savings>
              <SavingsValue>$273m</SavingsValue> on client savings.
            </Savings>
          </DecorationMiddleTop>
          <DecorationMiddleBottom>
            <DecorationMiddleBottomInner />
          </DecorationMiddleBottom>
        </DecorationMiddle>
      )}
      <DecorationRight restrained={!isDesktop}>
        <DecorationRightTop />
      </DecorationRight>
    </StyledContainer>
  );
}
